export default __webpack_public_path__ + "eb719cbde147a91f816ba49871f4e28a.svg";